module.exports = __webpack_public_path__ + "img/petstairs06.edc98fb1.jpg";